/**
 * COMPONENT: FormSelectWithCreate
 * Select avec bouton pour créer une nouvelle option
 */

import type { FieldPath, FieldValues } from 'react-hook-form';
import { Plus } from 'lucide-react';
import { FormSelect, type FormSelectProps } from './form-select';
import { Button } from './button';

interface FormSelectWithCreateProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends Omit<FormSelectProps<TFieldValues, TName>, 'ref'> {
  onCreateClick?: () => void;
  createButtonLabel?: string;
}

export function FormSelectWithCreate<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  onCreateClick,
  createButtonLabel = 'Créer',
  ...props
}: FormSelectWithCreateProps<TFieldValues, TName>) {
  return (
    <div className="flex gap-2">
      <div className="flex-1">
        <FormSelect {...props} />
      </div>
      {onCreateClick && (
        <Button type="button" variant="outline" size="sm" onClick={onCreateClick} className="mt-6">
          <Plus className="h-4 w-4 mr-1" />
          {createButtonLabel}
        </Button>
      )}
    </div>
  );
}
